import React from 'react'
import { Button, Modal, Tonality } from '@dsny/dsny-component-library'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useDispatch, connect, useSelector } from 'react-redux'
import { thunks as AuthThunks } from 'reducers/Auth'
import ModalActions from 'reducers/Modal'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import {
  XButtonWrapper,
  ButtonWrapper
} from '../SignoutModal/SignoutModal.styles'
import { Close } from '@dsny/dsny-component-library/icons'
import { StyledModal } from '../Modals.styles'
import { trackEvent } from 'utils/segmentService'

const mapStateToProps = ({ modal, profile }) => ({
  showResetPasswordConfirmationModal: modal?.showResetPasswordConfirmationModal
})

function ResetPasswordConfirmationModal({
  showResetPasswordConfirmationModal
}) {
  const { t } = useTranslation()
  const theme = useTheme()
  const dispatch = useDispatch()
  const isMobile = useMobileMediaQuery()
  const profile = useSelector((state) => state.profile?.profile)

  const handleCancelButtonClick = () => {
    dispatch(ModalActions.toggleResetPasswordConfirmationModal())
  }

  const sendResetPasswordInstructions = async () => {
    try {
      await dispatch(
        AuthThunks.requestForgotPwd({
          email: profile?.mailto
        })
      )
      dispatch(ModalActions.toggleResetPasswordConfirmationModal())
    } catch (error) {
      console.error(error?.data)
    }
  }

  return (
    <StyledModal
      $isMobile={isMobile}
      isOpen={showResetPasswordConfirmationModal}
      onClose={handleCancelButtonClick}
      analyticsModalType="reset_password_confirmation"
      trackEvent={trackEvent}
      containerStyles={{
        padding: isMobile ? '24px 12px' : '72px 64px 40px'
      }}
    >
      <XButtonWrapper onClick={handleCancelButtonClick}>
        <Close width={24} height={24} color={theme.colors.neutralW80} />
      </XButtonWrapper>

      <Tonality.UIHeading
        headingStyle="headline5"
        color={theme.colors.neutralW90}
        style={{ lineHeight: 2 }}
      >
        {t('settings.reset-password-confirmation-modal-title')}
      </Tonality.UIHeading>

      <Tonality.UIText
        textStyle="body"
        color={theme.colors.neutralW70}
        style={{ fontSize: 14, marginBottom: 32 }}
      >
        {t('settings.reset-password-confirmation-modal-body')}
      </Tonality.UIText>

      <ButtonWrapper>
        <Button
          variant="primary"
          setting="player"
          mode="dark"
          onClick={sendResetPasswordInstructions}
        >
          {t('settings.send-email-with-instructions')}
        </Button>
      </ButtonWrapper>
    </StyledModal>
  )
}

export default connect(mapStateToProps)(ResetPasswordConfirmationModal)
